import React, { useState, useEffect } from "react";
import { BiSolidMoon, BiSolidSun } from "react-icons/bi";

const DarkMode = () => {
	const [theme, setTheme] = useState(
		localStorage.getItem("theme") || "light"
	);

	useEffect(() => {
		const element = document.documentElement;

		if (theme === "dark") {
			element.classList.add("dark");
		} else {
			element.classList.remove("dark");
		}

		localStorage.setItem("theme", theme);
	}, [theme]);

	const toggleTheme = () => {
		setTheme(theme === "dark" ? "light" : "dark");
	};

	return (
		<button
			onClick={toggleTheme}
			className="relative w-10 h-10 rounded-xl bg-gray-100 dark:bg-gray-800 flex items-center justify-center transition-all duration-300 hover:bg-gray-200 dark:hover:bg-gray-700 hover:scale-110 group"
			title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
		>
			<div className="relative w-5 h-5">
				<BiSolidSun
					className={`absolute inset-0 text-xl text-amber-500 transition-all duration-300 ${
						theme === "dark"
							? "opacity-100 rotate-0 scale-100"
							: "opacity-0 rotate-90 scale-50"
					}`}
				/>
				<BiSolidMoon
					className={`absolute inset-0 text-xl text-indigo-500 transition-all duration-300 ${
						theme === "light"
							? "opacity-100 rotate-0 scale-100"
							: "opacity-0 -rotate-90 scale-50"
					}`}
				/>
			</div>
		</button>
	);
};

export default DarkMode;
